export default "__VITE_ASSET__B6dyiBXH__"